module.exports = __webpack_public_path__ + "assets/img/img-prize2-d390b9ba.png";